import { makeObservable, observable, action, computed } from "mobx";
import {
  uploadAndCommitFile,
  uploadAndCommitCache,
} from "../file/NovaFileManagerModel";
import { PATH_PREFIX } from "../../constants/request";
import PromiseAllLimit from "../../utils/PromiseAlllimit";
import { set } from "../../utils/immutable";
import { deleteFile } from "../../services/richmodal";
import { commitFile } from "../../services/videoEdit";
import {
  EVideoUploadStatus,
  IUploadCheckResult,
  IVideoFileUploadInfo,
} from "./types";
import { UploadedFile } from "logic/src/objects/file/types";
import { sendCLK } from "../../utils/eventTrack";
import { MAX_VIDEO_DURATION } from "./constants";
import {
  filterValidVideos,
  getVideoMetaData,
  getVideoThumbnail,
} from "./utils";

export default class Video {
  @observable.ref fileList: IVideoFileUploadInfo[] = [];
  @observable currentVideo = {
    index: 1,
    seekTime: "00:00",
  };

  @computed
  get allDuration() {
    return this.fileList.reduce((pre, cur) => pre + (cur.duration || 0), 0);
  }

  @computed
  get allDone() {
    return this.fileList.every(
      item => item.uploadStatus === EVideoUploadStatus.UPLOADED,
    );
  }

  constructor() {
    makeObservable(this);
  }

  init() {
    this.fileList = [];
  }

  setFileList(v: IVideoFileUploadInfo[]) {
    this.fileList = v;
  }

  deleteFile = (v: IVideoFileUploadInfo) => {
    const newFileList = this.fileList.filter(item => item.file !== v.file);
    this.setFileList(newFileList);
    if (v?.uploadStatus === EVideoUploadStatus.UPLOADED) {
      deleteFile(v.fileId!);
    }
  };

  @action.bound
  setCurrentVideoIndex(v: number) {
    this.currentVideo = {
      ...this.currentVideo,
      index: v,
    };
  }

  @action.bound
  setCurrentVideoSeekTime(v: string) {
    this.currentVideo = {
      ...this.currentVideo,
      seekTime: v,
    };
  }

  async uploadUrl(url: string) {
    const res = await commitFile({ url });
    // cacheFile(res.thumbnail, res.fileId);
    return res;
  }

  uploadFiles = async (list: File[]): Promise<IUploadCheckResult> => {
    const files: File[] = [...list];
    let appendFileList: IVideoFileUploadInfo[] = [];
    try {
      appendFileList = await Promise.all(
        files.map(async (item: File) => {
          const metaData = await getVideoMetaData(item);
          return {
            file: item,
            url: URL.createObjectURL(item),
            fileId: "",
            uploadStatus: EVideoUploadStatus.UPLOADING,
            metaData: metaData,
          };
        }),
      );
    } catch (e) {
      return {
        durationError: true,
      }; // 视频时长获取失败
    }
    const [checkedFileList, checkResult] = filterValidVideos(
      appendFileList,
      MAX_VIDEO_DURATION - this.allDuration,
    );

    appendFileList = checkedFileList;

    appendFileList = await Promise.all(
      appendFileList.map(async (item: IVideoFileUploadInfo) => {
        try {
          const [thumbnailUrl, thumbnail] = await getVideoThumbnail(item.file!);
          return {
            ...item,
            thumbnailUrl: thumbnailUrl,
            thumbnail: thumbnail,
          };
        } catch (e) {
          return item;
        }
      }),
    );

    const newFileList: IVideoFileUploadInfo[] = [
      ...this.fileList,
      ...appendFileList,
    ];
    this.setFileList(newFileList);
    const uploadList = appendFileList.filter(item => item.file);
    if (!uploadList.length) {
      return checkResult;
    }

    PromiseAllLimit(
      uploadList.map(file => () => this.uploadFile(file.file!)),
      3,
    );
    return checkResult;
    //返回校验结果
  };

  async uploadFile(file: File) {
    sendCLK("video_upload_initiate", "视频理解_触发视频上传");
    return uploadAndCommitFile(
      file,
      `${PATH_PREFIX}/video-edit/v1.0.0/commit`,
    ).then((info: UploadedFile) => {
      const fileIndex = this.fileList.findIndex(it => it.file === file);
      let temp = set<IVideoFileUploadInfo[]>(
        this.fileList,
        [fileIndex, "uploadStatus"],
        info.status !== "success"
          ? EVideoUploadStatus.UPLOAD_FAILED
          : EVideoUploadStatus.UPLOADED,
      );

      temp = set<IVideoFileUploadInfo[]>(
        temp,
        [fileIndex, "fileId"],
        info.file_id,
      );

      this.setFileList(temp);
      this.uploadThumbnail(this.fileList[fileIndex]);
      if (info.status === "success") {
        sendCLK("video_upload_success", "视频理解_视频上传成功");
      } else {
        sendCLK("video_upload_fail", "视频理解_视频上传失败");
      }
    });
  }

  uploadThumbnail(v: IVideoFileUploadInfo) {
    if (v.thumbnail) {
      uploadAndCommitCache(v.thumbnail, v.fileId);
    }
  }

  // uploadVideo = async (file: File) => {
  //   this.setUploadStatus(EVideoUploadStatus.UPLOADING);
  //   this.setVideoUrl(URL.createObjectURL(file));
  //   const fileInfo = await uploadAndCommitFile(
  //     file,
  //     `${PATH_PREFIX}/video-edit/v1.0.0/commit`,
  //   );
  //   console.log("[uploadVideo model] fileInfo", fileInfo);
  //   // const fileDetail = await getFileDetail(fileInfo?.file_id || "");
  //   if (fileInfo.status !== "success") {
  //     this.setUploadStatus(EVideoUploadStatus.UPLOAD_FAILED);
  //     // this.setVideoUrl(fileInfo.url);
  //     return fileInfo;
  //   }
  //   // this.setVideoUrl(fileDetail.url);
  //   this.setVideoFileId(fileInfo.file_id || "");
  //   // this.setVideoUrl('https://bilibili.github.io/WebAV/video/bunny_0.mp4');
  //   this.setUploadStatus(EVideoUploadStatus.UPLOADED);
  //   return fileInfo;
  // };
}
